import React from 'react'
import { withRouter, Route, Switch, Redirect } from 'react-router-dom'
import Recipe from './recipe'
import RecipesList from './recipesList'

import RecipeLoader from './loader'

const Recipes = props => <Switch>
  <Route
    path="/recipes"
    exact
    component={RecipesList}
  />
  <Route
    path="/recipes/:recipeId"
    render={
      ({ match: { params: { recipeId } } }) =>
        <RecipeLoader
          recipeId={recipeId}
          key={recipeId}
          component={() => <Recipe key={`i_${recipeId}`} recipeId={recipeId}/>}
        />
    }
  />
  <Redirect to="/recipes"/>
</Switch>



export default withRouter(Recipes)
